module.exports = __webpack_public_path__ + "static/media/Innovative Teaching Learning Pallavi Nair.fdaf5c58.pdf";